export enum ShortSize {
  'XS' = 'XS',
  'Small' = 'S',
  'Medium' = 'M',
  'Large' = 'L',
  'XL' = 'XL',
  '1X' = '1X',
  '2X' = '2X',
  '3X' = '3X',
  '4X' = '4X',
}

export const isShortSize = (maybeShortSize: unknown): maybeShortSize is ShortSize => {
  try {
    return Object.values(ShortSize).includes(maybeShortSize as ShortSize);
  } catch (error) {
    return false;
  }
};

export enum LongSize {
  'XS' = 'XS',
  'Small' = 'Small',
  'Medium' = 'Medium',
  'Large' = 'Large',
  'XL' = 'XL',
  '1X' = '1X',
  '2X' = '2X',
  '3X' = '3X',
  '4X' = '4X',
}

export const isLongSize = (maybeLongSize: unknown): maybeLongSize is LongSize => {
  try {
    return Object.values(LongSize).includes(maybeLongSize as LongSize);
  } catch (error) {
    return false;
  }
};

export const shortSizeToLongSize = (shortSize: ShortSize): LongSize => {
  switch (shortSize) {
    case ShortSize.XS:
      return LongSize.XS;
    case ShortSize.Small:
      return LongSize.Small;
    case ShortSize.Medium:
      return LongSize.Medium;
    case ShortSize.Large:
      return LongSize.Large;
    case ShortSize.XL:
      return LongSize.XL;
    case ShortSize['1X']:
      return LongSize['1X'];
    case ShortSize['2X']:
      return LongSize['2X'];
    case ShortSize['3X']:
      return LongSize['3X'];
    case ShortSize['4X']:
      return LongSize['4X'];
  }
};
